/// <amd-module name="Core/Medius.Core.Web/Scripts/components/invoice/invoiceRemark"/>

import { Card, LocalizationContext, StringMap, TextArea } from "@medius/ui-controls";
import * as React from "react";
import { getCultureCode } from "Core/Medius.Core.Web/Scripts/Medius/lib/utils/user";
import { mapFromNorthstarToApa } from "Core/Medius.Core.Web/Scripts/lib/northstarLocalization";
import { translate } from "Core/Medius.Core.Web/Scripts/lib/globalization";

export interface InvoiceRemarkProps {
    invoiceRemark: string,
    onInvoiceRemarkChange: (invoiceRemark: string) => void
}

export default function InvoiceRemarkComponent({ invoiceRemark, onInvoiceRemarkChange }: InvoiceRemarkProps) {
    return (
        <div className="accordion-group">
            <LocalizationContext.Provider value={{
                translate: (key: string, _, defaultValue?: string, args?: StringMap) => mapFromNorthstarToApa(key, defaultValue, args),
                getLocale: () => getCultureCode()
            }}>
                <Card
                    data-testid="invoice-remark-card"
                    title={translate('#Enterprise/invoiceRemark')}
                    isCollapsible={true}
                    defaultOpen={invoiceRemark.length > 0}
                    headerHeight="small"
                >
                    <TextArea
                        data-testid="invoice-remark-text"
                        value={invoiceRemark}
                        width="fill"
                        onChange={(e) => {
                            const newInvoiceRemark = e.target.value;
                            onInvoiceRemarkChange(newInvoiceRemark);
                        }}
                    />
                </Card>
            </LocalizationContext.Provider>
        </div>
    );
}
